import { render, staticRenderFns } from "./IpBlacklist.vue?vue&type=template&id=cb5bb9ba&scoped=true"
import script from "./IpBlacklist.vue?vue&type=script&lang=js"
export * from "./IpBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5bb9ba",
  null
  
)

export default component.exports